<script setup>
import { errorToasts } from './error-toast-state'
import './error-toast-logic'
import ErrorToast from './ErrorToast'
</script>

<template>
  <div class="position-fixed top-0 start-50 translate-middle-x mt-5 pt-3 mtr-on-top">
    <ErrorToast
      v-for="(error, index) in errorToasts"
      :key="index"
      :error
    />
  </div>
</template>
